import useSWR from 'swr'

import type {CompanyV2 as Company} from '@pleo-io/deimos'

import {useLoggedInUser} from '@product-web/user'

import {getDeimos} from './helpers'

export function useCompany() {
    const {companyId} = useLoggedInUser()
    const result = useSWR<Company | null, Error>(
        companyId ? `/rest/v2/companies/${companyId}` : null,
        getDeimos,
    )

    return result
}
